import React from 'react';

import CaseTeamsListAdd from './List';
export default function Index() {
  return (
    <>
      <CaseTeamsListAdd />
    </>
  );
}
